import React, { useRef, useEffect, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { resizeGameHandler } from '../helpers';
import { gameMainDrawer } from './drawers/gameMainDrawer';
import { liveConnection } from '../core';
import { gameStore } from '../store/gameStore';
import { getBrowserVisibilityProp } from '../helpers/documentVisibility';
import { applicationStore } from '../store/applicationStore';
import { MAX_USER_INACTIVE_STATE_DURATION } from '../core/constants';
import { gameService } from '../services';

let timeOutId;
export const GameMain = observer(() => {
  const { canvasTranslationKeys } = gameStore;
  const { hasJackPot } = applicationStore;

  const ref = useRef();
  useEffect(() => {
    if (!ref.current || !Object.keys(canvasTranslationKeys).length) return;
    gameMainDrawer.execute(ref.current).then(() => {
      liveConnection.connectionInitCallback();
      resizeGameHandler();
      window.addEventListener('resize', resizeGameHandler);
    });
  }, [ref, canvasTranslationKeys]);

  const onVisibilityChange = useCallback(() => {
    gameMainDrawer.popupBar.visibilityChangeHandler();
  }, []);

  const checkUserInActiveState = useCallback(() => {
    clearTimeout(timeOutId);
    timeOutId = setTimeout(() => {
      gameService.sendLauncherErrorCode();
    }, MAX_USER_INACTIVE_STATE_DURATION);
  }, []);

  useEffect(() => {
    if (hasJackPot) {
      liveConnection.jackpotConnectionInitCallback();
    }
  }, [hasJackPot]);

  useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp();
    document.addEventListener(visibilityChange, onVisibilityChange, false);
    checkUserInActiveState();
    document.addEventListener('click', checkUserInActiveState);
    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange);
      document.removeEventListener('click', checkUserInActiveState);
    };
  }, []);

  return (
    <div className='canvas-container'>
      <div className='canvas-wr' ref={ref} />
    </div>
  );
});
